import { AlertProps } from "@alm/flow-ds/components";
import { AxiosError } from "axios";
import { createAlertAction } from "data/app/appActions";
import { createErrorAlert } from "lib/api/errors";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { createAlert } from "records/Alert";
import store from "store";

export const useAlertsHandler = () => {
	const { t } = useTranslation();

	const addAlert = useCallback(
		(
			alert: string,
			alertStatus: AlertProps["status"],
			timeout?: number
		) => {
			const newAlert = {
				title: t(`alerts.${alert}.title`),
				status: alertStatus,
				description: t(`alerts.${alert}.description`),
				timeout:
					timeout !== undefined
						? timeout
						: alertStatus === "error"
						? 0
						: 3000,
			};
			store.dispatch(createAlertAction(createAlert(newAlert)));
		},
		[t]
	);

	const addErrorAlert = useCallback((response: AxiosError, error: string) => {
		store.dispatch(createAlertAction(createErrorAlert(response, error)));
	}, []);

	return { addAlert, addErrorAlert };
};
